import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { OrderInformationComponent } from './containers/order-information/order-information.component';
import { TlkIncrementalNumberInputComponent } from '@itero/ui-toolkit-angular/incremental-number-input';

@NgModule({
	declarations: [OrderInformationComponent],
	imports: [CommonModule, SharedModule, TlkIncrementalNumberInputComponent],
	exports: [OrderInformationComponent]
})
export class OrderInformationModule {}
